import modelBase from '../models/model-base.model';
import globalConfig from '../config/global-variables'
import loginModel from '../models/login.model'

const languageModel = {

  getLanguageText: function (successCallBack, failureCallBack, text) {
    var path = '/api/codemaster/language/category/' + text;
    modelBase.get(successCallBack, failureCallBack, path);
  },
  getLanguages: function (successCallBack, failureCallBack) {
    modelBase.get(successCallBack, failureCallBack, '/api/codemaster/language');
  },
  getCountries: function (successCallBack, failureCallBack) {
    modelBase.get(successCallBack, failureCallBack, '/api/codemaster/userCountry');
  },
  getLanguageDate: function (successCallBack, failureCallBack, text) {
    var path = '/api/codemaster/language/date/' + text;
    modelBase.get(successCallBack, failureCallBack, path);
  },
  getText: (code, defaultText) => {
    try {
      return (globalConfig.LanguageData[code][loginModel.credentials.language] || globalConfig.LanguageData[code]["en"]);
    } catch {
      return (defaultText || code);
    }
  }
}

export default languageModel;
